<template>
<div class="footer-main-out">
    <div class="line"></div> 
    
    <div class="footer-main">
        
        <div class="footer-item" v-bind:key="item" v-for="item in items" @click="gototerms()">
                {{item}}
        </div>
        <div class="footer-item" @click="gotocontact">
            Contact Us
        </div>

    </div>
    <div class="handles">
        <img src="../../assets/discord.png" id="disco" @click="disco">
        <img src="../../assets/instagram.png" id="ig" @click="ig">
        <img src="../../assets/twitter.png" id="tweet" @click="twitter">
        
    </div>
    <div class="credit">&#9642; Created and maintained by <a @click="gotoabout"><b id="teamcolo">Team CodeGill</b></a> &#9642;
    </div>
    <div class="credit2">2020 &#9400;Copyright. All Rights Reserved.
    </div>
</div>
</template>

<script>
export default {
    name:'Footer',
    data(){
        return{
            items:['Terms-of-service','Disclaimer','PrivacyPolicy']
        }
    },  
    methods:{
        gotoabout(){
            this.$router.push('/AboutUs').catch(err => {console.log(err);console.clear();})
        this.menu_drop_active=false
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        },
        gototerms(){
            this.$router.push('/Terms').catch(err => {console.log(err);console.clear();})
        this.menu_drop_active=false
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        },
        gotocontact(){
            this.$router.push('/ContactUs').catch(err => {console.log(err);console.clear();})
        this.menu_drop_active=false
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        },
        disco(){
            window.open('https://discord.gg/tyT5stA')
            
        },
        ig(){
            
            window.open('https://www.instagram.com/teamcodegill') 
            
        },
        twitter(){
            
            window.open('https://twitter.com/TeamCodeGill')
        }
    }
}
</script>

<style scoped>
    #teamcolo{
        color: #7e70d4;
        cursor: pointer;
    }
    .handles>img{
        margin:0.3rem;
        width: 1.5rem;
        cursor: pointer;
    }
    #disco{
        background-color: #7184d6;
        border-radius:50% ;
        
        padding: 2px;
    }
    #ig{
        background: white;
        width: 1.7rem;
        /* border-radius:50% ; */
        
    }
    #tweet{
        
         background-color: #1ea1f2;
          border-radius:50% ;
          
          padding: 2px;
    }
    .credit{
        
        font-family: 'Poppins','san-serif';
    }
    .credit2{
        margin-bottom: 3rem;
         font-family: 'Poppins','san-serif';
    }
    .footer-main{
        
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 0.5rem;
    }
    .footer-item{
        margin: 0.5rem;
        font-family: 'Poppins','san-serif';
        font-size: 0.9rem;
        cursor: pointer;
    }
    .footer-item:hover{
        text-decoration: underline;
    }
    .line{
        width: 100%;
        border-top: 1px solid rgb(170, 170, 170);
    }
    .footer-main-out{
        background-color: rgba(255, 255, 255, 0.753);
        margin-top: 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    @media screen and (max-width:768px){
        .footer-item{
        margin-left: 1rem;
        font-size: 0.7rem;
        }    
        .credit{
        font-size:0.7rem ;
        }  
        .credit2{
         font-size:0.7rem ;   
        } 

    }
</style>